export default __webpack_public_path__ + "static/media/outdent.60f58614.svg";